/* GLO ARCADE page: whole-dollar prices, the Check Availability glide and a soft reveal as sections scroll in. */
(function () {
  var doc = document;
  if (!/\btk-gp--glo-arcade\b/.test(doc.body.className)) return;

  /* whole-dollar prices: $67, not $67.00 */
  Array.prototype.forEach.call(doc.querySelectorAll('gp-product-price [data-gp-text]'), function (el) {
    var t = el.textContent.trim();
    if (/^\$[\d,]+\.00$/.test(t)) el.textContent = t.slice(0, -3);
  });
  /* the bundle buy button says the same thing as the others, with the live price */
  var bb = doc.querySelector('[data-id="gkvpViUIdz"]');
  var bp = bb && bb.querySelector('.gp-button-price .gp-money');
  var bl = bb && bb.querySelector('.button-text');
  if (bl && bp && bp.textContent.trim()) bl.textContent = 'Buy GLO ARCADE - ' + bp.textContent.trim();

  /* Check Availability: glide down so the bundle breakdown, the price and the buy button all sit in view.
     Runs in the capture phase, ahead of the generic jump-link handler in tkgp.js. */
  var glideRaf = 0;
  function bundleSpot() {
    var top = doc.querySelector('[data-id="gaFXD7vrr2"]'), btn = doc.querySelector('[data-id="gkvpViUIdz"]');
    var end = doc.querySelector('[data-id="g_6SJa9Ail"]') || btn;
    if (!top || !btn) return null;
    var a = top.getBoundingClientRect().top + scrollY, z = end.getBoundingClientRect().bottom + scrollY;
    var room = innerHeight, pad = innerWidth < 768 ? 16 : 32, y;
    /* the whole block fits: centre it, nudged a little high so it reads as the focus of the screen */
    if (z - a + pad * 2 <= room) y = a - (room - (z - a)) * 0.42;
    /* too tall for the screen: keep the buy button in view and show as much of the breakdown as fits */
    else y = z + pad - room;
    return Math.max(0, Math.min(doc.documentElement.scrollHeight - room, y));
  }
  function glide() {
    cancelAnimationFrame(glideRaf);
    /* show the bundle now, so it settles in as we arrive instead of popping in after */
    Array.prototype.forEach.call(doc.querySelectorAll('#shopify-section-gp_global_section_593221565823320879-2 .tkg-r'), function (el) { el.classList.add('is-in'); });
    var from = scrollY, first = bundleSpot();
    if (first === null) return false;
    var dur = Math.min(1500, Math.max(800, 500 + Math.abs(first - from) * 0.12)), start = 0;
    var ease = function (x) { return x < 0.5 ? 4 * x * x * x : 1 - Math.pow(-2 * x + 2, 3) / 2; };
    var html = doc.documentElement, prev = html.style.scrollBehavior;
    html.style.scrollBehavior = 'auto';
    function off() {
      html.style.scrollBehavior = prev;
      ['wheel', 'touchstart', 'keydown'].forEach(function (e) { removeEventListener(e, stop); });
    }
    function stop() { cancelAnimationFrame(glideRaf); off(); }
    ['wheel', 'touchstart', 'keydown'].forEach(function (e) { addEventListener(e, stop, { passive: true }); });
    function step(now) {
      if (!start) start = now;
      var k = Math.min(1, (now - start) / dur), to = bundleSpot();
      scrollTo(0, from + ((to === null ? first : to) - from) * ease(k));
      if (k < 1) glideRaf = requestAnimationFrame(step); else off();
    }
    glideRaf = requestAnimationFrame(step);
    return true;
  }
  doc.addEventListener('click', function (ev) {
    var a = ev.target.closest && ev.target.closest('a[href="#gvObneSbTZ"]');
    if (!a || ev.metaKey || ev.ctrlKey || ev.shiftKey) return;
    if (!glide()) return;
    ev.preventDefault();
    ev.stopPropagation();
  }, true);

  if (!('IntersectionObserver' in window)) return;
  if (matchMedia('(prefers-reduced-motion: reduce)').matches) return;
  var picks = [
    /* section headings */
    '[data-id="gA0hGo2bB5"]', '[data-id="goprvyPRWA"]', '[data-id="gNeQPxjN0_"]', '[data-id="giQelBviXq"]',
    /* pack cards */
    '[data-id="gIMSz_VzWp"]', '[data-id="gWRUIDgXfJ"]', '[data-id="gQM7hm-3l8"]', '[data-id="g0wAAeUflK"]', '[data-id="g-dNZNIrM1"]',
    '[data-id="g_2MTuUwb0"]', '[data-id="g92xDiiGU0"]', '[data-id="gdwOkn3tFR"]', '[data-id="gr6EEDsJhp"]', '[data-id="g5-7lb46yj"]',
    /* bundle, trust strip, testimonials, DAW art, about, buy band */
    '[data-id="gaFXD7vrr2"]', '[data-id="gEw1lCYwg0"] img', '[data-id="gZqdMhkwZp"] img', '[data-id="gwewfrWg4a"]', '.tkg-buy-band .tkg-btn',
    '#shopify-section-gp_section_558681029096441075 gp-icon-list'
  ];
  var els = [];
  picks.forEach(function (sel) {
    Array.prototype.forEach.call(doc.querySelectorAll(sel), function (el, i) {
      if (el.classList.contains('tkg-r')) return;
      /* anything already on screen at load stays put: no pop-in above the fold */
      var r = el.getBoundingClientRect();
      if (r.top < innerHeight * 0.92 && r.bottom > 0) return;
      el.classList.add('tkg-r');
      if (i) el.style.setProperty('--tkg-d', Math.min(i, 3) * 0.08 + 's');
      els.push(el);
    });
  });
  if (!els.length) return;
  var io = new IntersectionObserver(function (es) {
    es.forEach(function (e) {
      if (!e.isIntersecting) return;
      io.unobserve(e.target);
      e.target.classList.add('is-in');
      /* drop the delay once shown so hovers respond at once */
      setTimeout(function () { e.target.style.removeProperty('--tkg-d'); }, 1400);
    });
  }, { rootMargin: '0px 0px -10% 0px', threshold: 0.01 });
  doc.documentElement.classList.add('tkg-motion');
  els.forEach(function (el) { io.observe(el); });
  /* a jump link can skip past things; show everything above where we land */
  addEventListener('scroll', function () {
    els.forEach(function (el) { if (!el.classList.contains('is-in') && el.getBoundingClientRect().bottom < 0) { io.unobserve(el); el.classList.add('is-in'); } });
  }, { passive: true });
})();
